import { Typography } from '@saucelabs/ds-typography';
import React, { ReactNode } from 'react';
import { Link } from '@saucelabs/ds-link';
import { ProgressCircle } from '@saucelabs/ds-progress';

import { graphql } from '../../graphql/__generated__';
import { DiffHeaderInfoFragment } from '../../graphql/__generated__/graphql';
import { formatDate, TimeMode } from '../common/DateLabel';
import Truncate from '../common/Truncate';

type Props = {
  diff: DiffHeaderInfoFragment | undefined | null;
}

graphql(`
  fragment DiffHeaderInfo on Diff {
      id
      createdAt
      snapshot {
          id
          name
          jobUrl
          testName
          suiteName
      }
  }
`);

const DiffHeaderInfo: React.FC<Props> = ({ diff }) => {
  const meta: ReactNode[] = diff && diff.snapshot ? [
    diff.snapshot.suiteName && (
      <Truncate
        text={diff.snapshot.suiteName}
        variant="body"
      />
    ),
    diff.snapshot.testName && (
      <Truncate
        text={diff.snapshot.testName}
        variant="body"
      />
    ),
    <Truncate
      className="min-w-8"
      text={`Taken at ${formatDate[TimeMode.DATE](diff.createdAt)}`}
      variant="body"
    />,
    diff.snapshot.jobUrl && (
      <Link
        isExternal
        to={diff.snapshot.jobUrl}
        variant="secondary"
      >
        View Automated Test
      </Link>
    ),
  ] : [];

  const formattedMeta = meta
    .filter(Boolean)
    .reduce((prev: ReactNode[], curr) => (
      prev.length > 0 ? prev.concat([
        <Typography variant="body">|</Typography>,
        curr,
      ]) : [curr]
    ), []);

  if (!(diff && diff.snapshot)) {
    return (
      <div className="h-3">
        <ProgressCircle size="medium" />
      </div>
    );
  }

  return (
    <div className="min-w-0">
      <div className="flex mb-0.5">
        <Typography
          className="text-high-emphasis my-0 truncate"
          disableSpacing
          variant="heading-5"
        >
          {diff.snapshot.name}
        </Typography>
      </div>
      <div className="flex mr-2 text-medium-emphasis whitespace-nowrap gap-1">
        {formattedMeta}
      </div>
    </div>
  );
};

export default DiffHeaderInfo;
